import { friendly_token } from '../utils/utils';

export default function CertDetails ({ certificate, mini })
{
  if ( certificate ) {
    var element = certificate.metadata.element;
    var weight  = certificate.metadata.weight;
    var purity  = certificate.metadata.purity;
    var date    = new Date( certificate.history.added.date ) ;
    var id      = certificate.id.split(':')[1];
  }

  return (
    <>
    { certificate && (
    <div className="cert-details--">
        <div className="detail-row">
            <span className="label">Tipo:</span>
          <span className="value">{ element }</span>
        </div>
        <div className="detail-row">
            <span className="label">Peso:</span>
          <span className="value">{ weight } Gr.</span>
        </div>
        <div className="detail-row">
            <span className="label">Purezza:</span>
          <span className="value">{ purity }</span>
        </div>
        <div className="detail-row">
            <span className="label">Attivato:</span>
          <span className="value">{`${date.getDate()}/${date.getDay()}/${date.getFullYear()}`}</span>
        </div>

      { certificate.transactionID &&
        <div className="ingot-token mt-2">Pubblico su rete Bitcoin</div>
      }
    </div>
    )}
    </>
  );
}
